import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TokenStorageService } from './token-storage.service';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private tokenStorage: TokenStorageService,
  ) {}

  getSalesStatistics(fromDate?: string, toDate?: string): Observable<SalesStatistics> {
    let params = new HttpParams();

    if (fromDate) {
      params = params.set('from_date', `${fromDate}T00:00:00Z`);
    }
    if (toDate) {
      params = params.set('to_date', `${toDate}T23:59:59Z`);
    }

    return this.http.get<SalesStatistics>(`${this.apiUrl}/statistics/sales`, { params });
  }
}

export interface SalesStatistics {
  total_vouchers_sold: number;
  total_turnover: number;
  current_unused_value: number;
  total_vouchers_redeemed: number;
  total_vouchers_refunded: number;
  // Internal (raffle/giveaway) vouchers are excluded from the figures above because
  // no payment happened; reported here so the difference stays visible.
  internal_vouchers_count?: number;
  internal_vouchers_value?: number;
  internal_vouchers_unused_value?: number;
  internal_vouchers_redeemed?: number;
}
